module.exports = __webpack_public_path__ + "img/app-icon.3cc269e2.png";